import { generateUUID } from '../utilities';
import { APP_STYLING, CONTENT_STYLING, TEXT_TO_SPEECH } from './';

// Local settings from LOCAL_SETTINGS_WITH_DEFAULTS that should be configured for the user on a per-epub basis.
export const LOCAL_SETTINGS_WITH_DEFAULTS_SPECIFIC_TO_EPUB = {
  backToLabel: null,
  backToUrl: null,
  bookContentBasePath: null,
  contentStyling: {
    enabled: () => CONTENT_STYLING.DEFAULTS.ENABLED,
    fontFamily: () => CONTENT_STYLING.DEFAULTS.FONT_FAMILY,
    fontSize: () => CONTENT_STYLING.DEFAULTS.FONT_SIZE,
    lineHeight: () => CONTENT_STYLING.DEFAULTS.LINE_HEIGHT,
    letterSpacing: () => CONTENT_STYLING.DEFAULTS.LETTER_SPACING,
    pageMargin: () => CONTENT_STYLING.DEFAULTS.PAGE_MARGIN,
    theme: () => CONTENT_STYLING.DEFAULTS.THEME,
  },
  mostRecentBookLocation: {
    documentIndex: 0,
    cfi: null,
    timestamp: null,
  },
  processingReportPk: null,
  shouldShowPDFWarning: true,
  documentsDesignatedAvailableOffline: '[]',
};

// If the user does not have a given local setting in their localStorage, fall back on the default values in this object.
export const LOCAL_SETTINGS_WITH_DEFAULTS = {
  appStyling: {
    colorPalette: () => APP_STYLING.DEFAULTS.COLOR_PALETTE,
  },
  deviceUUID: () => generateUUID(),
  isUsingForcedOffline: false,
  mostRecentBook: {
    pk: null,
    timestamp: null,
  },
  showCopiedContentIndicators: true,
  shouldShowTTSDialog: true,
  ttsZoomPreference: null, // 'fit' or 'leaveAsIs'
  showCopiedContent: false,
  textToSpeech: {
    voice: '',
    volume: () => TEXT_TO_SPEECH.DEFAULTS.VOLUME,
    rate: () => TEXT_TO_SPEECH.DEFAULTS.RATE,
    shouldContinueToNextDocument: true,
  },
  useKeyboardShortcuts: true,
  useCacheStorage: true, // can be disabled in development environments so that changes apply faster
  newV7Counter: 3,
  shouldShowCollabUI: false,
  accessOfflineContentDialog: {
    shouldDisplay: true,
    closeTimestamp: null,
  },
  disableIdleMonitor: false,
  alwaysDownloadDocuments: null,
  // Cross-tab session tracking
  sessionTracking: {
    mostRecentActivityTimestamp: null,
    inactivityDialogOpen: false,
    inactivityDialogExpiresAt: null,
    shouldLogout: false, // Flag to trigger logout in all tabs
  },
  ...LOCAL_SETTINGS_WITH_DEFAULTS_SPECIFIC_TO_EPUB,
};
